<template>
  <div v-if="!reactionsDisabled || commentsEnabled || $slots.default" class="engagement-bar" data-testid="engagement-bar">
    <!-- Reactions (left) -->
    <div v-if="!reactionsDisabled" class="engagement-bar__reactions">
      <span class="engagement-bar__label">Reactions</span>
      <Reactions :id="id" />
    </div>

    <!-- Comment count (right) — clickable to switch to comments tab -->
    <button v-if="commentsEnabled" class="engagement-bar__comments" data-testid="engagement-bar-comments" @click="requestTab('#comments')">
      <Icon name="general.chat" size="sm" />
      <span>{{ commentCount }} {{ commentCount === 1 ? 'Comment' : 'Comments' }}</span>
    </button>

    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook';

import Reactions from '@/modules/viewer/components/Reactions.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useCommentsStore } from '@/modules/viewer/store/useCommentsStore';
import { useActiveTabTrigger } from '@/modules/viewer/composables/useActiveTab';

const { requestTab } = useActiveTabTrigger();

const viewerItemStore = useViewerItemStore();
const commentsStore = useCommentsStore();

const { id, commentsEnabled, reactionsDisabled } = storeToRefs(viewerItemStore);

const commentCount = computed(() => commentsStore.list?.length ?? 0);
</script>

<style scoped>
.engagement-bar {
  @apply flex flex-wrap items-center gap-3 sm:gap-4 py-2 sm:py-3;
}

.engagement-bar__reactions {
  @apply flex flex-wrap items-center gap-2 sm:gap-3;
}

.engagement-bar__label {
  @apply text-sm font-medium text-zinc-600 dark:text-zinc-400 mr-1;
}

.engagement-bar__comments {
  @apply flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-200 hover:bg-zinc-50 dark:hover:bg-zinc-800 rounded-lg transition-colors cursor-pointer;
}
</style>
